import { MediaGridSkeleton } from "./MediaGridSkeleton";
import { MediaListSkeleton } from "./MediaListSkeleton";

export const MediaContainerSkeleton = ({ isGridView }: { isGridView: boolean }) => {
    return <>{isGridView ? <MediaGridSkeleton /> : <MediaListSkeleton />}</>;
};
